export default "__VITE_ASSET__dffbfdff__"